'use es6';

import I18n from 'I18n';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Small from 'UIComponents/elements/Small';
import UIBox from 'UIComponents/layout/UIBox';
import { Routes } from '../constants/route/DashboardRoute';
import { useCounter } from '../hooks/timedHooks';
import * as DashboardRouter from '../lib/dashboard-router';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SECONDS_BEFORE_REDIRECT = 10;
const NotFound = props => {
  const {
    history,
    dashboard
  } = props;
  const handleHomeClick = () => {
    DashboardRouter.route(Routes.DASHBOARD, null, null, history);
  };
  const {
    currentValue: secondsLeftToRedirect
  } = useCounter({
    initial: SECONDS_BEFORE_REDIRECT,
    onFinish: handleHomeClick
  });
  const renderMessage = () => {
    if (dashboard) {
      return /*#__PURE__*/_jsx("h3", {
        children: I18n.text('message.scopeError')
      });
    }
    return /*#__PURE__*/_jsx("h3", {
      "data-test-id": "missing-dashboard-error",
      children: I18n.text('message.missingDashboard')
    });
  };
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBlockStart: "1000",
    paddingBlockStart: "1000",
    children: /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        children: [renderMessage(), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "message.redirecting",
            options: {
              secondsLeft: secondsLeftToRedirect
            }
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: handleHomeClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "message.goBack"
          })
        })]
      })
    })
  });
};
NotFound.propTypes = {
  dashboard: PropTypes.instanceOf(Immutable.Map),
  history: PropTypes.object.isRequired
};
export default withRouter(NotFound);